<div class="skeleton-card-grid">
  <div class="skeleton-card" *ngFor="let _ of placeholders">
    <div class="skeleton skeleton-card__title"></div>
    <div class="skeleton skeleton-card__chip"></div>
    <div class="skeleton skeleton-card__line"></div>
    <div class="skeleton skeleton-card__line skeleton-card__line--short"></div>
  </div>
</div>
